<div class="contact-person">
  <div class="contact-person__person-wrapper" *ngIf="contactPerson.firstName || contactPerson.lastName">
    <div class="contact-person__avatar">
      <brt-image [image]="contactPerson.avatar"></brt-image>
    </div>
    <div class="contact-person__name">
      {{ contactPerson.firstName }} {{ contactPerson.lastName }}
      <ng-container *ngIf="contactPerson.position.length">
        <br/><span class="contact-person__name-position">{{contactPerson.position}}</span>
      </ng-container>
    </div>
  </div>

  <ul class="contact-person__contacts">
    <li class="contact-person__contact" *ngFor="let communicationItem of contactPerson.communicationEntries">
      <brt-contact-link [type]="communicationItem.type" [value]="communicationItem.value" [label]="communicationItem.value"></brt-contact-link>
    </li>
  </ul>
</div>
